import "core-js/modules/es6.array.filter.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.object.to-string.js";
import * as types from './types';
import { FAST_TIMER } from '~/const/timers';
import fetchProductList from '~/services/layer';
import { fetchProducts as _fetchProducts } from '~/services/product';
function timer() {
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve();
    }, FAST_TIMER);
  });
}
export default {
  fetchProducts: function fetchProducts(store, payload) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var currentState, productList, products, filteredProducts;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            store.commit(types.SET_LOADING_LAYER, true);
            currentState = store.state;
            if (!payload.security) {
              _context.next = 5;
              break;
            }
            _context.next = 5;
            return timer();
          case 5:
            if (!(payload.payload !== currentState.latest)) {
              _context.next = 7;
              break;
            }
            return _context.abrupt("return");
          case 7:
            _context.next = 9;
            return fetchProductList(_this, payload.payload);
          case 9:
            productList = _context.sent;
            _context.next = 12;
            return _fetchProducts(_this, productList);
          case 12:
            products = _context.sent;
            if (!(payload.payload !== currentState.latest)) {
              _context.next = 15;
              break;
            }
            return _context.abrupt("return");
          case 15:
            filteredProducts = products.filter(function (product) {
              return product.stock.status !== null;
            });
            store.commit(types.SET_LAYER_PRODUCTS, filteredProducts);
            productList = null;
            products = null;
            store.commit(types.SET_LOADING_LAYER, false);
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  resetProducts: function resetProducts(_ref) {
    var commit = _ref.commit;
    commit(types.RESET_LAYER_PRODUCTS, []);
  },
  setCurrentLayer: function setCurrentLayer(store, payload) {
    var data = payload;
    store.commit(types.SET_CURRENT_LAYER, data);
    data = null;
  },
  appendItems: function appendItems(store, payload) {
    store.commit(types.APPEND_ITEMS, payload);
  }
};